import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { DownloadSimple, WarningCircle } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ViewFile() {
  const { fileId } = useParams();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");

  const qs = `token=${encodeURIComponent(token)}`;
  const fileUrl = `${API}/api/files/public/${encodeURIComponent(fileId)}?${qs}`;

  useEffect(() => {
    fetch(`${API}/api/files/public/${encodeURIComponent(fileId)}/meta?${qs}`)
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.detail || "Link non valido o scaduto");
        setMeta(data);
      })
      .catch((e) => setError(e.message));
  }, [fileId, qs]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="view-file-error">
        <div className="max-w-sm text-center space-y-3">
          <WarningCircle size={40} className="mx-auto text-amber-600" />
          <div className="font-semibold text-slate-900">{error}</div>
          <p className="text-sm text-muted-foreground">Chiedi a Housetag di inviarti un nuovo link oppure apri il documento dalla pratica.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-slate-100" data-testid="view-file-page">
      <header className="shrink-0 flex items-center gap-3 px-4 py-3 bg-white border-b">
        <div className="min-w-0 flex-1">
          <div className="text-[11px] font-semibold uppercase tracking-wider text-purple-700">Housetag</div>
          <div className="text-sm font-semibold text-slate-900 truncate" data-testid="view-file-name">
            {meta?.filename || "Caricamento…"}
          </div>
        </div>
        <a
          href={`${fileUrl}&download=1`}
          className="inline-flex items-center gap-1.5 rounded-md ht-gradient text-white px-4 py-2 text-sm font-semibold"
          data-testid="view-file-download-btn"
        >
          <DownloadSimple size={16} weight="bold" /> Scarica
        </a>
      </header>
      {meta && (
        <iframe
          src={fileUrl}
          title={meta.filename}
          className="flex-1 w-full border-0 bg-white"
          data-testid="view-file-frame"
        />
      )}
    </div>
  );
}
